import LocalStorageUtils from '@/utils/localStorageUtils'
import Config from '~/config/index'
import axios from 'axios'

function pingHost (host)
{
    const isHttps = host.includes('https')
    host = host.replace(/https?:\/\//, '')

    return new Promise(async (resolve, reject) =>
    {
        let res
        const startedAt = performance.now()

        try
        {
            res = await axios.get(`http${isHttps ? 's' : ''}://${host}`)
        }
        catch (error)
        {
            res = error
        }
        finally
        {
            res = res || {}
            const elapsedTime = Number.parseFloat((performance.now() - startedAt).toString().substr(0, 6))
            const hasResponse = JSON.stringify(res) != '{}' && res.response || res.status == 200

            if (hasResponse) resolve(elapsedTime)
            else reject(elapsedTime)
        }
    })
}

function isResourceAvailable(url)
{
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    try
    {
        http.send();
    }
    catch (e)
    {
        console.error(e)
        
        return false
    }

    return http.status != 404
}

export default
{
    get apiUrl ()
    {
        return LocalStorageUtils.useLocalApi ? Config.localApiUrl: Config.distApiUrl
    },

    get cdnUrl ()
    {
        return LocalStorageUtils.useLocalCdn ? Config.localCdnUrl : Config.distCdnUrl
    },

    pingHost,
    isResourceAvailable
}


// WEBPACK FOOTER //
// ./src/utils/servicesUtils.js